<template>
  <div id="chart" class="pr-0">
    <apexchart
      type="line"
      :height="height || '350vh'"
      :options.sync="chartOptions"
      :series="series"
    />
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DashboardGraphicArea',
  props: ['series', 'tipo', 'range', 'height'],
  data() {
    return {
      timeOffset: new Date().getTimezoneOffset() * 1000 * 60,
      chartOptions: {
        chart: {
          type: 'line',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
          curve: 'straight',
        },
        title: {
          text: `${this.tipo}`,
          align: 'left',
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          type: 'datetime',
          labels: {
            formatter: function (timestamp) {
              return moment(new Date(timestamp)).format('HH:mm')
            },
          },
          max: new Date().getTime(),
          range: this.range || 1000 * 60 * 60 * 1, // (ms * s * m * h)
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)
            },
          },
          tickAmount: 5,
          min: 0,
          max: undefined,
        },
      },
    }
  },
  beforeMount() {
    this.chartOptions.yaxis.max = this.series.every((e) =>
      e.data.every((s) => s[1] === 0)
    )
      ? 100
      : undefined
  },
}
</script>
